// Golden Live Orders Popup JavaScript
(function() {
  // Array of sample orders
  const orders = [
    { name: "Daniel", location: "CA", product: "Golden® 1 Bottle", time: "21 minutes ago" },
    { name: "Cicelly", location: "CA", product: "Golden® 1 Bottle", time: "43 minutes ago" },
    { name: "Damu", location: "CA", product: "Golden® 1 Bottle", time: "1 hour 6 minutes ago" },
    { name: "Daniel", location: "CA", product: "Golden® 1 Bottle", time: "1 hour 30 minutes ago" },
    { name: "Timothy", location: "NE", product: "Golden® 1 Bottle", time: "1 hour 55 minutes ago" },
    { name: "Brandon", location: "CO", product: "Golden® 1 Bottle", time: "2 hours 21 minutes ago" },
    { name: "James", location: "PA", product: "Golden® 1 Bottle", time: "2 hours 48 minutes ago" },
    { name: "Tilo", location: "CA", product: "Golden® 4 Bottles", time: "3 hours 16 minutes ago" },
    { name: "Chris", location: "IA", product: "Golden® 1 Bottle", time: "3 hours 45 minutes ago" },
    { name: "Shameer", location: "CA", product: "Golden® 4 Bottles", time: "4 hours 15 minutes ago" },
    { name: "Larry", location: "GA", product: "Golden® 1 Bottle", time: "27 minutes ago" },
    { name: "Jonathan", location: "CA", product: "Golden® 1 Bottle", time: "56 minutes ago" },
    { name: "Esther", location: "TX", product: "Golden® 1 Bottle", time: "1 hour 26 minutes ago" },
    { name: "Shawn", location: "MD", product: "Golden® 1 Bottle", time: "1 hour 57 minutes ago" },
    { name: "Stacey", location: "TN", product: "Golden® 1 Bottle", time: "2 hours 29 minutes ago" },
    { name: "Gemal", location: "NJ", product: "Golden® 1 Bottle", time: "3 hours 2 minutes ago" },
    { name: "Abdullah", location: "CA", product: "Golden® 1 Bottle", time: "3 hours 36 minutes ago" },
    { name: "Tilo", location: "NY", product: "Golden® 6 Bottles", time: "4 hours 11 minutes ago" },
    { name: "Philip", location: "NY", product: "Golden® 1 Bottle", time: "4 hours 47 minutes ago" },
    { name: "Dmetreus", location: "FL", product: "Golden® 1 Bottle", time: "5 hours 24 minutes ago" },
    { name: "Craig", location: "NY", product: "Golden® 1 Bottle", time: "30 minutes ago" },
    { name: "Lisa", location: "SC", product: "Golden® 1 Bottle", time: "1 hour ago" },
    { name: "Aida", location: "QC", product: "Golden® 3 Bottles", time: "1 hour 31 minutes ago" },
    { name: "Maryam", location: "CA", product: "Golden® 1 Bottle", time: "2 hours 3 minutes ago" },
    { name: "Angel", location: "FL", product: "Golden® 2 Bottles", time: "2 hours 36 minutes ago" },
    { name: "Albert", location: "CA", product: "Golden® 1 Bottle", time: "3 hours 10 minutes ago" },
    { name: "Lance", location: "FL", product: "Golden® 2 Bottles", time: "3 hours 45 minutes ago" },
    { name: "Dawna", location: "CA", product: "Golden® 1 Bottle", time: "4 hours 21 minutes ago" },
    { name: "Greg", location: "IN", product: "Golden® 1 Bottle", time: "4 hours 58 minutes ago" },
    { name: "Brandon", location: "MO", product: "Golden® 1 Bottle", time: "5 hours 36 minutes ago" }
  ];

  // Display popup function
  function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-image">
          <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/Golden_wPills_Zoom.png?v=1733785205" alt="Product Image">
          <span class="glow-dot"></span>
        </div>
        <div class="popup-text">
          <div class="popup-line">
            <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
          </div>
          <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
          <div class="popup-line order-time">${randomOrder.time}</div>
          <div class="verified-buyer-badge">Verified Buyer</div>
        </div>
      </div>
    `;
    popup.style.display = 'block';

    setTimeout(() => {
      popup.classList.add('popup-hide');
    }, 6000); // Show for 5 seconds

    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('popup-hide');
      setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
  }

  // Random time intervals between popups
  function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
  }

  // Start the popup display
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
  });
})();
